import { render, staticRenderFns } from "./saleOrders.vue?vue&type=template&id=c6e5b5fc&scoped=true"
import script from "./saleOrders.vue?vue&type=script&lang=js"
export * from "./saleOrders.vue?vue&type=script&lang=js"
import style0 from "./saleOrders.vue?vue&type=style&index=0&id=c6e5b5fc&prod&scoped=true&lang=scss"
import style1 from "./saleOrders.vue?vue&type=style&index=1&id=c6e5b5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e5b5fc",
  null
  
)

export default component.exports